import React from "react";
import {
  PDFViewer,
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  BlobProvider,
} from "@react-pdf/renderer";
import { Stack } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import pfdImage from "../../Assets/Logo/pdflogo-g.png";
import pfdImageText from "../../Assets/Logo/pdflogo-text-g.png";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    flexWrap: "wrap",
    padding: 5,
  },
  column: {
    width: "25%",
    padding: 5,
  },
  cell: {
    border: 1,
    borderColor: "#000",
    borderRadius: 8,
    paddingTop: 8,
    paddingBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  textStyle: {
    padding: 5,
    fontSize: 6,
  },
  image: {
    width: 120,
    height: 112,
    borderRadius: 5,
  },
  imagePrent: {},
  barHeading: {
    color: "black",
    fontWeight: "bold",
    fontSize: "17px",
  },
  imageChildPdf: {
    width: 80,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "0px",
  },
  imagePdfText: {
    width: 120,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "0px",
  },
});

const GeneratePdfKit = () => {
  const { PdfKitData } = useSelector((state) => state.KITMANAGEMENT);
  const navigate = useNavigate(); // Initialize useNavigate hook for navigation
  if (PdfKitData.length === 0) {
    return <p>No Pdf Found Yet </p>;
  }

  const handleClose = () => {
    navigate("/kit"); // Navigate back to home page
  };

  // Function to create a page with 4x4 data
  const getPages = (data) => {
    const pages = [];
    const itemsPerPage = 16; // 4x4 grid = 16 items per page
    const totalPages = Math.ceil(data.length / itemsPerPage);

    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
      const pageData = data.slice(
        pageIndex * itemsPerPage,
        (pageIndex + 1) * itemsPerPage
      );
      pages.push(
        <Page size="A4" style={styles.page} key={pageIndex}>
          {pageData.map((user, index) => (
            <View style={styles.column} key={index}>
              <View style={styles.cell}>
                <Image src={pfdImageText} style={styles.imagePdfText} />
                <Image src={user.qr_code_url} style={styles.image} />
                <View style={styles.imagePrent}>
                  <Image
                    src={pfdImage}
                    alt="pdfimage"
                    style={styles.imageChildPdf}
                  />
                </View>
              </View>
              <Text style={styles.textStyle}>{user.qr_code}</Text>
            </View>
          ))}
        </Page>
      );
    }

    return pages;
  };

  const MyDocument = (
    <Document title="kitbatchPDF">
      {PdfKitData && getPages(PdfKitData)}
    </Document>
  );

  return (
    <Stack className="row-gap-3 p-2 p-md-0">
      {/* Close button */}
      <div>
        <button
          onClick={handleClose}
          style={{
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            padding: "0.5rem 1rem",
            borderRadius: "0.25rem",
            cursor: "pointer",
            float: "right",
          }}
        >
          Close
        </button>
      </div>
      {/* PDF Viewer */}
      <BlobProvider document={MyDocument}>
        {({ blob, url, loading, error }) => {
          if (loading) {
            return (
              <Stack
                style={{
                  height: "600px",
                }}
                className="align-items-center justify-content-center text-center w-100 flex-grow-1"
              >
                <p>Preparing PDF, please wait...</p>
                <div className="loader"></div>
              </Stack>
            );
          }

          if (error) {
            return <p>Error generating PDF: {error.message}</p>;
          }

          return <PDFViewer src={url} width="100%" className="flex-grow-1" />;
        }}
      </BlobProvider>
    </Stack>
  );
};

export default GeneratePdfKit;
